import { PeopleRole } from "../models/peopleCandidate";
import axiosConfig from "./axiosConfig";

export interface FindPeopleResponse {
  status: "pending";
  operationKey: string;
  siteId: string;
  // True when an identical find-people run was already in flight for this
  // (row, role) and we coalesced onto it rather than spawning a second run.
  deduped?: boolean;
}

// Kick off step-5 people discovery for a promoted lead's chosen company in a
// given role (landlord/tenant) as a long-running operation. Returns
// {operationKey, siteId} immediately; the worker runs Apollo People Search +
// an LLM ranking pass and writes the ranked shortlist onto the lead's
// contactCandidates[role]. The FE polls useOperation(operationKey, siteId)
// until terminal, then refetches the lead to show the people.
const postLeadFindPeople = async (
  authToken: string,
  leadId: string,
  role: PeopleRole,
  // Optional operator-typed company domain; the BE hands it to Apollo for an exact
  // org match (falling back to the name search if it resolves nobody).
  domainOverride?: string
): Promise<FindPeopleResponse> => {
  const { data } = await axiosConfig.post(
    `/leads/${leadId}/find-people`,
    { role, ...(domainOverride ? { domainOverride } : {}) },
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postLeadFindPeople;

// Same, keyed by a VOA search row's assessment ref (the pre-promotion surface).
export const postVoaFindPeople = async (
  authToken: string,
  sourceRef: string,
  role: PeopleRole,
  domainOverride?: string
): Promise<FindPeopleResponse> => {
  const { data } = await axiosConfig.post(
    `/leads/voa-find-people`,
    { sourceRef, role, ...(domainOverride ? { domainOverride } : {}) },
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};
